import React from 'react';
import Typography from '@material-ui/core/Typography';

const LoadingMessage = () => (
  <Typography variant="subtitle1">We are loading your data ...</Typography>
);

export default LoadingMessage;
